import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation, Outlet } from 'react-router-dom';
import Home from './pages/home';
import Login from '../src/pages/login.jsx';
import SingUp from '../src/pages/singUp.jsx';
import Payment from '../src/pages/payment.jsx';
import Activation from '../src/pages/activation.jsx';
import CardService from '../src/pages/cardService.jsx';
import Balance from '../src/pages/balance.jsx';
import Catalog from '../src/pages/catalog.jsx';
import Categories from '../src/pages/categories.jsx';
import AboutUs from '../src/pages/aboutUs.jsx';
import ContactUs from '../src/pages/contactUs.jsx';
import Faq from '../src/pages/faq.jsx';
import Rules from '../src/pages/rules.jsx';
import ChangePassword from '../src/pages/changePassword.jsx';
import ProductDetail from '../src/pages/productDetail.jsx';
import ShoppingCart from '../src/pages/shoppingCart.jsx';
import Form from './components/sing-up/form.jsx';
import Navbar from './layout/navbar/navbar';
import Design from './pages/design';
import PaymentResult from './pages/paymentResult';
import Panel from './pages/panel';
import PageList from './pages/pageList.jsx';
import ShortLink from './pages/shortLink.jsx';
import { isMobile } from 'react-device-detect'; 
import GA4RouteTracker from './components/GA4RouteTracker'; // ✅ اضافه‌شده

// Component that decides whether to show Navbar based on route
const Layout = () => {
  const location = useLocation();

  // مسیرهایی که Navbar نمایش داده نمی‌شود
  const noNavbarRoutes = ['/login', '/sign-up', '/sign-up/form', '/change-password'];
  const isCardServiceRoute = location.pathname.toLowerCase().startsWith('/cardservice');

  // CardService: هدر در موبایل و دسکتاپ نمایش داده شود.
  // رفتار سایر مسیرها بدون تغییر باقی می‌ماند.
  const shouldShowNavbar = isCardServiceRoute
    ? true
    : (isMobile || !noNavbarRoutes.includes(location.pathname));

  return (
    <>
      {shouldShowNavbar && <Navbar />}
      <Outlet /> {/* Outlet برای نمایش صفحات داخلی */}
    </>
  );
};

const RouterComponent = () => {
  return (
    <Router>
      {/* ✅ ردیاب گوگل آنالیتیکس داخل Router قرار گرفت */}
      <GA4RouteTracker />

      <Routes>
        {/* Short-link redirect route outside Layout to avoid Navbar */}
        <Route path="/r/:code" element={<ShortLink />} />
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/sign-up" element={<SingUp />} />
          <Route path="/sign-up/form" element={<Form />} />
          <Route path="/activation" element={<Activation />} />
          <Route path="/activation/:rawCardCode/:exDate" element={<Activation />} />
          <Route path="/activation/:rawCardCode" element={<Activation />} />
          <Route path="/cardService" element={<CardService />} />
          <Route path="/cardService/:rawCardCode" element={<CardService />} />
          <Route path="/balance" element={<Balance />} />
          <Route path="/balance/:cardNumber" element={<Balance />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/rules" element={<Rules />} />
          <Route path="/categories" element={<Categories />} />
          <Route path="/productDetail" element={<ProductDetail />} />
          <Route path="/catalog" element={<Catalog />} />
          <Route path="/shopping-cart" element={<ShoppingCart />} />
          <Route path="/design" element={<Design />} />
          <Route path="/payment-result" element={<PaymentResult />} />
          <Route path="/panel" element={<Panel />} />
          <Route path="/pageList" element={<PageList />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default RouterComponent;
